/**
 * @param {String} str 输入的字符串 
 * @param {Number} maxNum 最大值 
 * @returns {Number} 输出一个大于0、小于maxNum、保留两位小数的数字
 */
 export function moneyRules(str,maxNum) {
	// 先把非数字的都替换掉，除了数字和.和-号
	str = str.replace(/[^\d\.]/g, '')
	 //前两位不能是0加数字      
	str = str.replace(/^0\d[0-9]*/g, '');
	//必须保证第一个为数字而不是.       
	str = str.replace(/^\./g, '');
	//保证只有出现一个.而没有多个.
	str = str.replace(/\.{2,}/g,'.');       
	//保证.只出现一次，而不能出现两次以上 
	str = str.replace('.','$#$').replace(/\./g,'').replace('$#$','.');  
	//如果第一位是负号，则允许添加
	str = str.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');  
	if (maxNum) {
		if (str > maxNum) str = maxNum;
	}
	return str
}
/**
 * @param {String} str 输入的字符串 
 * @param {Number} maxNum 最大值 
 * @returns {Number} 输出一个大于0、小于maxNum的正整数
 */
export function plusIntNumRules(str,maxNum) {
	// 先把非数字的都替换掉，除了数字和.和-号
	str = parseInt(str)
	if (maxNum) {
		if (str > maxNum) str = maxNum;
	}
	return str
}
/**
 * @param {Boolean} ifRequired 是否必填 true 必填，false 非必填
 * @returns 返回一个手机号验证Object，此对象用于elementUI的rules中的验证规则,实现手机号验证
 * */ 
export function mobilePhoneRuleObj(ifRequired) {
	let obj = {
		pattern: /^1[3456789]\d{9}$/,
		message: '手机号格式不正确',
		trigger: 'blur',
	}
	if (ifRequired) obj.required = true;
	return obj
}
/**
 * @param {Boolean} ifRequired 是否必填 true 必填，false 非必填
 * @returns 返回一个身份证验证Object，此对象用于elementUI的rules中的验证规则,实现身份证号验证
 * */ 
export function idCardRuleObj(ifRequired) {
	 let obj={
		pattern: /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
		message: '身份证号格式不正确',
		trigger: 'blur',
	}
	if (ifRequired) obj.required = true;
	return obj
}
/**
 * /^((6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])|[0-5]?\d{0,4})$/
 * @param {Boolean} ifRequired 是否必填 true 必填，false 非必填
 * @returns 返回一个ip验证Object，此对象用于elementUI的rules中的验证规则,实现身份证号验证
 * */ 
 export function ipRuleObj(ifRequired,val) {
	let obj={
	 pattern: /^((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}$/,
	 message: `${val}格式不正确`,
	 trigger: 'blur',
 }
 if (ifRequired) obj.required = true;
 return obj
}
/**
 * @param {Boolean} ifRequired 是否必填 true 必填，false 非必填
 * @returns 返回一个端口号验证Object，此对象用于elementUI的rules中的验证规则,实现身份证号验证
 * */ 
 export function portRuleObj(ifRequired,val) {
	let obj={
	 pattern: /^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-5]{2}[0-3][0-5])$/,
	 message: `${val}格式不正确(0~65535)`,
	 trigger: 'blur',
 }
 if (ifRequired) obj.required = true;
 return obj
}
/**
 * @param {Boolean} ifRequired 是否必填 true 必填，false 非必填
 * @returns 返回一个域名验证Object，此对象用于elementUI的rules中的验证规则,实现身份证号验证
 * */ 
 export function domainRuleObj(ifRequired,val) {
	let obj={
	 pattern: /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*$/,
	 message: `${val}格式不正确`,
	 trigger: 'blur',
 }
 if (ifRequired) obj.required = true;
 return obj
}
/**
 * @param {String} val 提示文字
 * @returns 返回是否必填验证对象，此对象用于elementUI的rules中的验证规则,实现身份证号验证
 * */ 
export function mustRequired(val) {
	let obj = {
	 required:true,
	 message: val+'不能为空',
	 trigger: 'blur',
 }
 return obj
} 
/**
 * ?merc=1&a=1格式转换成query对象
 * */ 
export function urlToQuery(url) {
    var theRequest = new Object();
    if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for(var i = 0; i < strs.length; i ++) {
            theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
    }
	console.log(theRequest);
    return theRequest;
} 
